import { Box, Button, Grid, Input, MenuItem, Popover, Stack, TextField, Typography } from '@mui/material'
import React, { useState } from 'react'
import { Field, Form } from 'react-final-form'
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { TextFieldCustom } from '../../components/FormElements';
import { EyeIcon, EyeOffIcon } from '../../components/IconComponent';
import { config_path, portalCfg } from '../../router/config.path';
import PublicPage from '../PublicPage';
import Modal from '../../components/Modal';
import validators, { composeValidators, required } from '../../utils/validators'
import SelectComponent from '../../components/Select';

export default function LoginWithEmailView(props) {
    const { isEmailOtp, message, defaultLanguage, languages, currentLanguage } = props;
    const [showPassword, setShowPassword] = useState(false);
    const [anchorElLanguage, setAnchorElLanguage] = useState(null);
    const { t } = useTranslation();
    const navigate = useNavigate();

    const handleOpenLanguages = (event) => {
        setAnchorElLanguage(event.currentTarget);
    };

    const onChangeLanguage = async (item) => {
        setAnchorElLanguage(null);
        props.onChangeLanguage(item);
    }

    console.log("defaultLanguage:", defaultLanguage);
    return (
        <PublicPage message={message} showProcessing={props.showProcessing} confirm={props.confirm}>
            <Grid item xs={12} marginTop={4}>
                <Typography variant='h4' textAlign={'center'}>{t('btn_login')}</Typography>
            </Grid>
            <Grid item xs={12} marginTop={4}>
                <Grid item xs={12}>
                    <Form
                        onSubmit={props.onSubmit}
                        render={({ handleSubmit }) => (
                            <form onSubmit={handleSubmit}>
                                <Grid item xs={12}>
                                    <Grid item xs={12} marginY={2}>
                                        <Field
                                            name="username"
                                            component={TextFieldCustom}
                                            label={t('email')}
                                            placeholder={t('enter_email')}
                                            isEdit={true}
                                            color='default'
                                            validate={validators.composeValidators(validators.validEmail)}
                                            autoFocus={true}
                                        />
                                    </Grid>
                                    <Grid item xs={12} marginY={2}>
                                        <Field
                                            name="password"
                                            component={TextFieldCustom}
                                            label={t('password')}
                                            placeholder={t('enter_password')}
                                            isEdit={true}
                                            color='default'
                                            validate={validators.composeValidators(validators.required)}
                                            autoFocus={true}
                                            type={showPassword ? 'text' : 'password'}
                                            endAdornment={<Grid item onClick={() => setShowPassword(!showPassword)}>{showPassword ? <EyeIcon /> : <EyeOffIcon />}</Grid>}
                                        />
                                    </Grid>
                                    <Grid item xs={12} container justifyContent={'flex-end'}>
                                        <Button id='loginEmail/bntForgotPassword' onClick={() => navigate(config_path.forgot_password)} variant='text'>{t('forgot_password')}</Button>
                                    </Grid>
                                    <Grid item xs={12} marginY={3}>
                                        <Button id='loginEmail/btnSubmit' size="large" fullWidth variant='contained' onClick={handleSubmit} type='submit'>{t('btn_submit')}</Button>
                                    </Grid>
                                </Grid>
                            </form>
                        )}
                    />
                </Grid>
            </Grid>

            <Grid item xs={12} container sx={{
                position: 'absolute',
                bottom: 0,
                width: 'calc(100% - 48px)',
                justifyContent: 'center',
                alignItems: 'center'
            }} >
                <Button onClick={(e) => handleOpenLanguages(e)} size='large' id='header/changeLanguage'>
                    {defaultLanguage ? defaultLanguage.label : ""}
                </Button>
            </Grid>

            <Popover id='list-languages'
                anchorEl={anchorElLanguage}
                open={Boolean(anchorElLanguage)}
                onClose={() => setAnchorElLanguage(null)}
                sx={{
                    top: 45,
                }}
            >
                {languages && languages.length > 0 && languages.map((item, index) => {
                    return (
                        <MenuItem key={index} onClick={() => onChangeLanguage(item)}>
                            <Typography variant='subtitle2'>{item.label}</Typography>
                        </MenuItem>
                    )
                })}
            </Popover>
            {props.showRegisterAction && <Modal
                isOpen={props.showRegisterAction}
                onClose={() => props.setShowRegisterAction(false)}
            >
                <Box>
                    <Stack direction={'row'}>
                        <Typography>{t('exits_rewards_participant')}</Typography>
                    </Stack>
                    <Stack marginTop={4} direction={'row'} justifyContent={'center'} alignItems={'center'}>
                        <Stack flex={1} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <img src={portalCfg.publicPath + '/assets/images/register_have_card.png'} alt={'Logo Image'} height={100} />
                            <Button id='loginEmail/btnRegisterHaveCard' onClick={() => navigate(config_path.register_existing_customer)} variant='contained'>{t('btn_register_have_card')}</Button>
                        </Stack>
                        <Stack flex={1} justifyContent={'center'} alignItems={'center'} spacing={2}>
                            <img src={portalCfg.publicPath + '/assets/images/register_new.png'} alt={'Logo Image'} height={100} />
                            <Button id='loginEmail/btnRegisterNew' onClick={() => navigate(config_path.register)} variant='contained'>{t('btn_register_new')}</Button>
                        </Stack>
                    </Stack>
                </Box>
            </Modal>}
        </PublicPage>
    )
}
